import { RequestActionDefinition } from './RequestActionDefinition.js';
import { extendJSONSchema } from '../utils/extendJSONSchema.js';

export const ResourceQueryActionDefinition = extendJSONSchema(
  RequestActionDefinition,
  {
    type: 'object',
    additionalProperties: false,
    required: ['type', 'resource'],
    properties: {
      type: {
        enum: ['resource.query'],
        description: 'Query a list of resources.',
      },
      resource: {
        type: 'string',
        description: 'The type of the resource to query.',
      },
      selectedGroupId: {
        $ref: '#/components/schemas/RemapperDefinition',
        description:
          'The ID of the group to scope the request to. Defaults to the currently selected group.',
      },
      view: {
        type: 'string',
        description: 'The view to use for the resource.',
      },
      query: {
        $ref: '#/components/schemas/RemapperDefinition',
        description: `A remapper that results in either an object containing each property of the query
string, or a string that gets passed through as-is.

Supported query parameters are \`$filter\`, \`$orderby\`, \`$select\`, \`$top\` (the maximum number of
resources to return) and \`$skip\` (the number of resources to skip). Combine \`$top\` and \`$skip\`
with \`$orderby\` to get stable pages.`,
      },
      own: {
        type: 'boolean',
        description:
          'If only the resources created by the authenticated app member should be included',
      },
    },
  },
  ['url', 'method'],
);
